var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4997V12.9997H2.5L9.87333 5.62638L7.37333 3.12638L0 10.4997ZM11.8067 3.69305C12.0667 3.43305 12.0667 3.01305 11.8067 2.75305L10.2467 1.19305C9.98667 0.933047 9.56667 0.933047 9.30667 1.19305L8.08667 2.41305L10.5867 4.91305L11.8067 3.69305Z",
    fill: "#9299A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d7014629bd0c99d8012f4bb6eca62461.svg";
export { ForwardRef as ReactComponent };